import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

const HotAndColdContext = createContext();

export const useHotAndCold = () => {
  return useContext(HotAndColdContext);
};

export const HotAndColdProvider = ({ children }) => {
  const [puzzles, setPuzzles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPuzzles = async () => {
      try {
        const { data: puzzlesData, error: puzzlesError } = await supabase
          .from('hotandcold_puzzles')
          .select(`
            date,
            title,
            hotandcold_clues (
              id,
              answer,
              hint_1,
              hint_2,
              hint_3,
              slug
            )
          `)
          .order('date', { ascending: false });

        if (puzzlesError) throw puzzlesError;

        if (puzzlesData && puzzlesData.length > 0) {
          const formattedPuzzles = puzzlesData.map(puzzle => {
            const sortedClues = puzzle.hotandcold_clues
              ? puzzle.hotandcold_clues
                  .map(c => ({
                    ...c
                    // Removed mapping hint_1 to text, as title is used for display now
                  }))
              : [];
            
            return {
              date: puzzle.date,
              title: puzzle.title,
              puzzleNumber: puzzle.title.match(/#(\d+)/) ? puzzle.title.match(/#(\d+)/)[1] : null,
              clues: sortedClues
            };
          });
          setPuzzles(formattedPuzzles);
        } else {
           setPuzzles([]);
        }
      } catch (err) {
        console.error('Error fetching Hot and Cold puzzles:', err);
        setError(err.message);
        setPuzzles([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPuzzles();
  }, []);

  const value = {
    puzzles,
    loading,
    error
  };

  return (
    <HotAndColdContext.Provider value={value}>
      {children}
    </HotAndColdContext.Provider>
  );
};

